export default __webpack_public_path__ + "static/media/welcome-company-logo.2cd20d4e.svg";